<script setup>

</script>

<template>
    <div>
      <!-- <div>
        <el-button type="primary" @click="showSearchView">搜索现有方案</el-button>
      </div> -->
        <el-form-item label="临时措施" prop="provisionalMeasures">
          <div style="margin-bottom: 15px;">
            <el-button type="primary" @click="showSearchView">搜索现有方案</el-button>
          </div>
          <div>
            <el-input v-model="form.provisionalMeasures" type="textarea" placeholder="请输入临时措施" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </div>
        </el-form-item>
      <div>
        <el-dialog width="650px !important" title="临时措施" :visible.sync="dialogVisible">
          <el-form label-width="50px">
            <el-form-item label="关键字">
              <div style="display: flex;">
                <el-input v-model="searchWord" placeholder="请输入关键字"></el-input>
                <el-button type="primary" style="margin-left: 10px;" @click="searchTempSolution">搜索</el-button>
              </div>
              <!-- <el-input v-model="searchWord" type="textarea" placeholder="请输入关键字" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input> -->

            </el-form-item>
            <div>
              <el-table :data="tempSolutionList" border>
                <el-table-column  type="expand">
                  <template #default="scope">
                    <div style="white-space: normal; padding: 0 10px;">{{scope.row.solutionDetail}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="临时措施" prop="solutionDetail" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="100" align="center">
                  <template #default="scope">
                    <el-button type="text" @click="selectSolution(scope.row)">选择</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- <div class="submitArea">
              <el-button plain  @click="dialogVisible = false">取消</el-button>
            </div> -->
          </el-form>
        </el-dialog>
      </div>
    </div>

</template>

<style scoped lang="scss">

</style>

<script>
//TODO 临时方案
import {requestSearchTempSolution} from "../../api/feedback";

/**
 * 临时方案表单
 */
export default {
  name: "kdTempSolutionForm",
  props: {
    provisionalMeasuresProp: String
  },
  data() {
    return {
      dialogVisible:false,
      tempSolutionList: [],
      searchWord:"",
      form: {
        provisionalMeasures: ""
      }
    }
  },
  watch: {
    provisionalMeasuresProp(newVal) {
      this.form.provisionalMeasures = newVal;
    },
    'form.provisionalMeasures': function (newVal,oldVal) {
      this.$emit('update:provisionalMeasuresProp', newVal)
    }
  },
  methods: {
    selectSolution(row){
        this.form.provisionalMeasures = row.solutionDetail;
        this.dialogVisible = false;
    },
    showSearchView(){
      this.dialogVisible = true;
    },
    searchTempSolution() {
      if(this.searchWord == ""){
        this.$DonMessage.warning("请输入关键字");
        return;
      }
      let searchParams = {
        keyWord: this.searchWord,
        type:2
      }
      requestSearchTempSolution(searchParams).then(res => {
        if(res.status == "0"){
          this.tempSolutionList = res.data;
        }else {
          this.$DonMessage.error(res.message);
        }
      })
    }
  }
}
</script>
